// Pure game helpers (no React) used by GameScreen

export const BOSS_HOVER_Y = 0.16;

export const newGame = () => ({
  phase: "intro",
  aliens: [],
  effects: [],
  typed: "",
  score: 0,
  lives: 5,
  spawned: 0,
  destroyed: 0,
  escaped: 0,
  lastSpawn: 0,
  startTime: 0,
  typedChars: 0,
  hitChars: 0,
  shakeUntil: 0,
  flashUntil: 0,
  flashColor: "#ff2a2a",
  boss: null,
});

export const makeNorm = (level) => (x) => (level.caseSensitive ? x : x.toLowerCase());

// initial position/velocity of the i-th missile for a boss attack pattern
export function missileLaunch(kind, b, level) {
  const i = b.fired;
  const n = kind.missiles;
  if (kind.pattern === "rain") {
    return { x: 10 + (i / (n - 1)) * 80, y: b.y + 0.1, vx: 0, vy: level.speed };
  }
  if (kind.pattern === "spray") {
    const side = i % 2 === 0 ? -1 : 1;
    return { x: b.x + side * 10, y: b.y + 0.02, vx: side * (40 + Math.random() * 15), vy: -level.speed * 0.6 };
  }
  if (kind.pattern === "spiral") {
    const angle = i * 1.1;
    return { x: b.x + Math.cos(angle) * 7, y: b.y + Math.sin(angle) * 0.05, vx: Math.cos(angle) * 34, vy: Math.sin(angle) * level.speed * 3 };
  }
  const angle = (i / n) * Math.PI * 2 + Math.random() * 0.5;
  return { x: b.x + Math.cos(angle) * 9, y: b.y + Math.sin(angle) * 0.07, vx: Math.cos(angle) * 28, vy: Math.sin(angle) * level.speed * 2.5 };
}

const lowest = (aliens, filter = () => true) => {
  let best = null;
  for (const a of aliens) if (filter(a) && (!best || a.y > best.y)) best = a;
  return best;
};

// the character the player should press next (" " = fire), or null
export function computeNextChar(s, norm) {
  const typed = norm(s.typed);
  const nextOf = (label) => {
    const l = norm(label);
    let i = 0;
    while (i < typed.length && i < l.length && typed[i] === l[i]) i++;
    if (i >= l.length && typed.length === l.length) return " ";
    return label[Math.min(i, l.length - 1)];
  };
  if (s.phase === "boss" && s.boss && s.boss.stage === "attack") {
    const token = s.boss.tokens[s.boss.hit];
    return token ? nextOf(token) : null;
  }
  // rainbow aliens never cost a life, so the guide ignores them
  const threats = s.aliens.filter((a) => !a.rainbow);
  if (threats.length === 0) return null;
  const target = lowest(threats, (a) => norm(a.label).startsWith(typed)) || lowest(threats);
  return nextOf(target.label);
}

export const matchesPrefix = (label, typed, norm) => {
  const t = typed.trim();
  return Boolean(t) && norm(label).startsWith(norm(t));
};
